// constants
import { CourseActionTypes } from "./constants";

export interface CourseActionType {
  type:
    | CourseActionTypes.API_RESPONSE_SUCCESS
    | CourseActionTypes.API_RESPONSE_ERROR
    | CourseActionTypes.UPDATE_COURSE
    | CourseActionTypes.CREATE_COURSE
    | CourseActionTypes.GET_COURSE
    | CourseActionTypes.UPDATE_COURSE_ENROLLMENT
    | CourseActionTypes.DELETE_COURSE;
  payload: {} | string;
}

interface courseDetails {
  id: string;
  name: string;
  categoryId: string;
  amount: string;
}

// common success
export const courseApiResponseSuccess = (
  actionType: string,
  data: courseDetails | {}
): CourseActionType => ({
  type: CourseActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const courseApiResponseError = (
  actionType: string,
  error: string
): CourseActionType => ({
  type: CourseActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createCourse = (
  name: string,
  categoryId: string,
  amount: string,
  offerAmount: string,
  description: string,
  description_ar: string,
  name_arabic: string,
  image: any,
  video: any,
  banner: any,
  enroll_text: string,
  enroll_text_ar: string,
  duration: any,
  enr_count: any,
  course_type:string,
  sortOrder: any,
  filter: any,
  status: any
): CourseActionType => ({
  type: CourseActionTypes.CREATE_COURSE,
  payload: {
    name,
    categoryId,
    amount,
    offerAmount,
    description,
    name_arabic,
    description_ar,
    image,
    video,
    banner,
    enroll_text,
    enroll_text_ar,
    duration,
    enr_count,
    course_type,
    sortOrder,
    filter,
    status,
  },
});

export const getCourse = (
  filter: string,
  status: string
): CourseActionType => ({
  type: CourseActionTypes.GET_COURSE,
  payload: { filter, status },
});

export const updateCourseEnrollment = (
  id: string,
  checked: string
): CourseActionType => ({
  type: CourseActionTypes.UPDATE_COURSE_ENROLLMENT,
  payload: { id, checked },
});

export const deleteCourse = (
  id: string,
  checked: any,
  filter: any,
  status: any
): CourseActionType => ({
  type: CourseActionTypes.DELETE_COURSE,
  payload: { id, checked, filter, status },
});
export const updateCourse = (
  id: string,
  name: string,
  categoryId: string,
  amount: string,
  offerAmount: string,
  description: string,
  description_ar: string,
  name_arabic: string,
  image: any,
  video: any,
  banner: any,
  enroll_text: string,
  enroll_text_ar: string,
  duration: any,
  enr_count: any,
  course_type:string,
  sortOrder: any,
  filter: any,
  status: any
): CourseActionType => ({
  type: CourseActionTypes.UPDATE_COURSE,
  payload: {
    id,
    name,
    categoryId,
    amount,
    name_arabic,
    description_ar,
    description,
    offerAmount,
    image,
    video,
    banner,
    enroll_text,
    enroll_text_ar,
    duration,
    enr_count,
    course_type,
    sortOrder,
    filter,
    status,
  },
});
